import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { pcmpProjectQueryKeys, setPcmpProjectStatus } from '../api/pcmpProjects.api';

interface SetPcmpProjectStatusVariables {
  id: number;
  displayName: string;
  isActive: boolean;
}

export function useSetPcmpProjectStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, isActive }: SetPcmpProjectStatusVariables) =>
      setPcmpProjectStatus(id, isActive),
    onSuccess: (_data, { id, displayName, isActive }) => {
      void queryClient.invalidateQueries({ queryKey: pcmpProjectQueryKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: pcmpProjectQueryKeys.detail(id) });
      toast.success(`${displayName} ${isActive ? 'activated' : 'deactivated'}`);
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to change the project status');
    },
  });
}
